import { render } from "./Top10TrafficReport.vue?vue&type=template&id=6192e10a"
import script from "./Top10TrafficReport.vue?vue&type=script&lang=js"
export * from "./Top10TrafficReport.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__